import { useEffect } from 'react';

type Callback = () => void;

/**
 * Hook này sử dụng ResizeObserver để theo dõi sự thay đổi kích thước của một phần tử DOM.
 * Mục đích là để kích hoạt một hành động (callback) khi nội dung thay đổi chiều cao.
 * @param ref React ref của phần tử cần theo dõi.
 * @param callback Hàm sẽ được gọi khi kích thước của phần tử thay đổi.
 */

const useContentResizeObserver = (ref: React.RefObject<HTMLElement>, callback: Callback) => {
  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    // 1. Khởi tạo ResizeObserver
    const observer = new ResizeObserver((entries) => {
      // Gọi callback mỗi khi có sự thay đổi kích thước
      // (Bao gồm cả khi các phần tử con mở/đóng)
      if (entries.length > 0) {
        callback();
      }
    });

    // 2. Bắt đầu theo dõi phần tử
    observer.observe(element);

    // 3. Cleanup: Ngừng theo dõi khi component unmount
    return () => {
      observer.unobserve(element);
      observer.disconnect();
    };
  }, [ref, callback]);
};

export default useContentResizeObserver;
